import { render, staticRenderFns } from "./Standings.vue?vue&type=template&id=c83e2bd4&scoped=true"
import script from "./Standings.vue?vue&type=script&lang=js"
export * from "./Standings.vue?vue&type=script&lang=js"
import style0 from "./Standings.vue?vue&type=style&index=0&id=c83e2bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83e2bd4",
  null
  
)

export default component.exports